module.exports = __webpack_public_path__ + "static/img/Inspection12.7bd9653d.jpg";